const styles = theme => ({
  paperCardFrame: {
    marginBottom: '24px',
    borderRadius: '0px',
    overflow: 'hidden',
  },
  titleHead: {
    background: '#F8F8F8',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    '& h1': {
      marginBottom: '0',
      marginRight: '8px',
      fontSize: '16px',
      '& $dangerText': {
        color: '#D2374F',
      },
    },
    '& $textGray': {
      fontSize: '14px',
      marginTop: '6px',
    },
  },
  radioGroup: {
    // justifyContent: 'space-around',
  },
  radio: {
    padding: '20px',
  },
  radioCheck: {
    '&$checked': {
      color: theme.palette.primary.lightADGMGreen,
    },
  },
  checked: {},
  nextprevBtnholder: {
    display: 'flex',
    marginBottom: '20px',
    '& button': {
      minWidth: '151px',
      padding: '15px',
      height: '60px',
      fontWeight: '600',
      fontSize: '16px',
      color: '#fff',
      textTransform: 'capitalize',
      '&:hover': {
        boxShadow: '1px 2px 10px rgba(0, 0, 0, 0.3)',
        background: 'none !important',
      },
    },
    '& $nextbtn': {
      background: theme.palette.primary.main,
      marginLeft: 'auto',
    },
    '& $backButton': {
      color: '#342D3D',
      border: '1px solid #342D3D',
      '&:disabled': {
        display: 'none',
      },
    },
  },
  backButton: {},
  nextbtn: {},
  '@media (min-width:768px)': {
    titleHead: {
      padding: '16px 24px',
      '& h1': {
        fontSize: '20px',
      },
    },
  },
  '@media (max-width: 767px)': {
    titleHead: {
      flexWrap: 'wrap',
    },
    paperCardFrame: {
      border: '0',
      borderRadius: '0',
    },
  },
});

export default styles;
